import { useQuery } from "react-query";
import { RestError } from "../../../services/rest-service/RestService";
import { IAlarmLynxGridModel } from "../../../services/summary-listing-data-service/AlarmLynxSummaryModels";
import SummaryListingDataService from "../../../services/summary-listing-data-service/SummaryListingDataService";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseAlarmLynxSummaryDataParameters = {
    groupID: number
} & BaseUseQueryParameters<IAlarmLynxGridModel>;

export function useAlarmLynxSummaryData({
    groupID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseAlarmLynxSummaryDataParameters) {
    return useQuery<IAlarmLynxGridModel, RestError>(
        keys.summaryData(groupID),
        ({ signal }) => {
            return SummaryListingDataService.getAlarmLynxData(groupID, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
